import { InternSet } from "internmap";
export default function disjoint(values, other) {
    var _a;
    var iterator = other[Symbol.iterator](), set = new InternSet();
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var v = values_1[_i];
        if (set.has(v))
            return false;
        var value = void 0, done = void 0;
        while ((_a = iterator.next(), value = _a.value, done = _a.done, _a)) {
            if (done)
                break;
            if (Object.is(v, value))
                return false;
            set.add(value);
        }
    }
    return true;
}
